import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import 'survey-core/survey-core.min.css';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './api/types/api.types';
import { MainRouter } from './routes/MainRouter';
import './styles/index.css';
import { createTheme, MantineColorsTuple, MantineProvider } from '@mantine/core';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorPageUnspecified } from './routes/components/ErrorPageUnspecified';
import { ExtendedCustomColors } from './colors';
import { useMemo, useState } from 'react';
import { generateColors } from '@mantine/colors-generator';

export const App = () => {
  const [primaryColor] = useState('#228be6');
  const generatedColors: Partial<Record<ExtendedCustomColors, MantineColorsTuple>> = useMemo(() => ({ 'primary-color': generateColors(primaryColor) }), [primaryColor]);
  const theme = createTheme({
    scale: 1,
    primaryColor: 'primary-color',
    colors: generatedColors,
  });
  return (
    <QueryClientProvider client={queryClient}>
      <MantineProvider theme={theme}>
        <ErrorBoundary fallback={<ErrorPageUnspecified />}>
          <MainRouter />
        </ErrorBoundary>
      </MantineProvider>
    </QueryClientProvider>
  );
};
